import { render, staticRenderFns } from "./price-card.vue?vue&type=template&id=87d4a1be&scoped=true"
import script from "./price-card.vue?vue&type=script&lang=js"
export * from "./price-card.vue?vue&type=script&lang=js"
import style0 from "./price-card.vue?vue&type=style&index=0&id=87d4a1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d4a1be",
  null
  
)

export default component.exports